import React from 'react';
import { motion } from 'framer-motion';
import { Landmark, Car, Zap } from 'lucide-react';
const INVESTOR_URL = 'https://project-flash-and-go-investor-landing-page-109.magicpatterns.app';
const stats = [{
  value: 'Desde U$S 10.000',
  label: 'Inversión mínima'
}, {
  value: '2% mensual',
  label: 'Rentabilidad'
}, {
  value: '24% anual',
  label: 'En dólares'
}, {
  value: 'Pagos mensuales',
  label: 'Sin demoras'
}];
const comparison = [{
  icon: Landmark,
  label: 'Plazo fijo en dólares',
  value: '0.5% mensual',
  badge: 'Mercado tradicional',
  highlight: false
}, {
  icon: Car,
  label: 'Competencia del sector',
  value: '~0.9% mensual',
  badge: 'Promedio del mercado',
  highlight: false
}, {
  icon: Zap,
  label: 'Flash & Go Inversiones',
  value: '2% mensual',
  subtext: '24% anual en dólares',
  badge: 'MÁS DEL DOBLE',
  highlight: true
}];
export function InversionesBanner() {
  return <section className="bg-[#111] border-y border-brand-gold/30" data-id="element-266">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-24" data-id="element-267">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-268">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-269">
            <div className="inline-block px-4 py-1.5 bg-brand-gold/10 border border-brand-gold text-brand-gold text-sm font-bold tracking-wider mb-6 rounded-full" data-id="element-270">
              2% MENSUAL — 24% ANUAL EN DÓLARES
            </div>
            <h2 className="font-heading text-5xl md:text-6xl mb-6" data-id="element-271">
              <span className="text-brand-white block" data-id="element-272">
                ¿Querés que tu dinero
              </span>
              <span className="text-brand-gold block" data-id="element-273">trabaje por vos?</span>
            </h2>
            <p className="text-xl text-brand-white/70 mb-8 max-w-lg" data-id="element-274">
              Flash & Go ya opera, ya genera y ya paga. Sumate a nuestra red de
              inversores y generá ingresos en dólares desde el primer mes. Sin
              complicaciones, sin sorpresas.
            </p>
            <div className="flex flex-wrap gap-3 mb-8" data-id="element-275">
              {['⚡ Modelo probado', '✅ Ya estamos pagando', '📈 Múltiples fuentes de ingreso'].map(pill => <span key={pill} className="bg-brand-black border border-brand-gold/40 text-brand-white/90 text-sm font-medium px-3 py-1.5 rounded-full" data-id="element-276">
                  {pill}
                </span>)}
            </div>
            <a href={INVESTOR_URL} className="inline-flex items-center justify-center px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-277">
              QUIERO INVERTIR →
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-black border border-brand-gold/20 p-6 sm:p-8 rounded-2xl" data-id="element-278">
            <div className="grid grid-cols-2 gap-x-6 gap-y-8" data-id="element-279">
              {stats.map((stat, i) => <div key={i} data-id="element-280">
                  <div className="font-heading text-3xl sm:text-4xl text-brand-gold mb-2 leading-none" data-id="element-281">
                    {stat.value}
                  </div>
                  <div className="text-brand-white/60 text-sm" data-id="element-282">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>

        {/* Comparison */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-20" data-id="element-283">
          <h3 className="font-heading text-4xl md:text-5xl text-brand-gold text-center mb-10" data-id="element-284">
            ¿Por qué Flash & Go?
          </h3>

          <div className="space-y-4 max-w-3xl mx-auto" data-id="element-285">
            {comparison.map((row, i) => {
            const Icon = row.icon;
            return <div key={i} className={`flex items-center gap-4 sm:gap-6 p-5 sm:p-6 rounded-xl border ${row.highlight ? 'bg-brand-gold/10 border-brand-gold' : 'bg-[#1A1A1A] border-white/5'}`} data-id="element-286">
                  <div className={`shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${row.highlight ? 'bg-brand-gold/20' : 'bg-white/5'}`} data-id="element-287">
                    <Icon className={`w-6 h-6 ${row.highlight ? 'text-brand-gold' : 'text-brand-white/40'}`} data-id="element-288" />
                  </div>

                  <div className="flex-grow min-w-0" data-id="element-289">
                    <p className={`font-bold text-sm sm:text-base ${row.highlight ? 'text-brand-white' : 'text-brand-white/70'}`} data-id="element-290">
                      {row.label}
                    </p>
                    <span className={`inline-block mt-1 text-[11px] font-bold px-2 py-0.5 rounded ${row.highlight ? 'bg-brand-gold text-brand-black' : 'bg-white/10 text-brand-white/50'}`} data-id="element-291">
                      {row.badge}
                    </span>
                  </div>

                  <div className="shrink-0 text-right" data-id="element-292">
                    <div className={`font-heading text-2xl sm:text-3xl leading-none ${row.highlight ? 'text-brand-gold' : 'text-brand-white/50'}`} data-id="element-293">
                      {row.value}
                    </div>
                    {row.subtext && <div className="text-brand-gold text-xs sm:text-sm mt-1" data-id="element-294">
                        {row.subtext}
                      </div>}
                  </div>
                </div>;
          })}
          </div>

          <p className="text-brand-gold text-center font-medium mt-8 mb-8 text-lg" data-id="element-295">
            Más del doble que cualquier alternativa del mercado.
          </p>

          <div className="text-center" data-id="element-296">
            <a href={INVESTOR_URL} className="inline-flex items-center justify-center px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-297">
              QUIERO INVERTIR →
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}